// Fathom Analytics integration

let fathomLoaded = false;

export async function initFathom() {
  const siteId = import.meta.env.VITE_FATHOM_SITE_ID;
  
  if (!siteId || import.meta.env.DEV) {
    console.log('Fathom Analytics skipped (missing VITE_FATHOM_SITE_ID or DEV mode)');
    return;
  }
  
  try {
    const { load, trackGoal } = await import('fathom-client');
    
    // Initialize Fathom with site ID from env
    load(siteId, {
      includedDomains: [window.location.hostname],
      spa: 'auto'
    });
    
    fathomLoaded = true;
    console.log('Fathom Analytics initialized');
    
    // Track initial page view
    trackPageView();
    
  } catch (error) {
    console.error('Failed to initialize Fathom:', error);
  }
}

export function trackPageView(path = window.location.pathname) {
  if (fathomLoaded && window.fathom) {
    window.fathom.trackPageview({
      url: path
    });
    console.log(`Page view tracked: ${path}`);
  } else {
    console.log(`Page view logged (Fathom not loaded): ${path}`);
  }
}

export function trackEvent(eventName, value = 0) {
  if (fathomLoaded && window.fathom) {
    window.fathom.trackGoal(eventName, value);
    console.log(`Event tracked: ${eventName}, value: ${value}`);
  } else {
    console.log(`Event logged (Fathom not loaded): ${eventName}, value: ${value}`);
  }
}

export function trackMissionEvent(action, missionId) {
  // Track mission-related events
  const eventName = `MISSION_${action.toUpperCase()}`;
  trackEvent(eventName, 0);
  
  // Custom event for detailed tracking
  window.dispatchEvent(new CustomEvent('mission-event', {
    detail: { action, missionId, timestamp: Date.now() }
  }));
}

export function trackTravelEvent(action, destination) {
  // Track travel-related events
  const eventName = `TRAVEL_${action.toUpperCase()}`;
  trackEvent(eventName, 0);
  
  // Custom event for detailed tracking
  window.dispatchEvent(new CustomEvent('travel-event', {
    detail: { action, destination, timestamp: Date.now() }
  }));
}

export function trackPurchaseEvent(item, cost) {
  // Track purchase/transaction events
  trackEvent('PURCHASE', cost);
  
  // Custom event for detailed tracking
  window.dispatchEvent(new CustomEvent('purchase-event', {
    detail: { item, cost, timestamp: Date.now() }
  }));
}

export function trackGameplayMetrics() {
  // Track general gameplay metrics
  const store = window.Alpine?.store('app');
  if (!store) return;
  
  const metrics = {
    playerLevel: store.player.level,
    money: store.player.money,
    health: store.player.health,
    completedMissions: store.missions.completed.length,
    timestamp: Date.now()
  };
  
  // Custom event for gameplay metrics
  window.dispatchEvent(new CustomEvent('gameplay-metrics', {
    detail: metrics
  }));
  
  console.log('Gameplay metrics tracked:', metrics);
}